/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApiFormButtonOnSave
 */
export interface ApiFormButtonOnSave {
  /**
   *
   * @type {boolean}
   * @memberof ApiFormButtonOnSave
   */
  loadEditFormInline?: boolean;
}

export function ApiFormButtonOnSaveFromJSON(json: any): ApiFormButtonOnSave {
  return ApiFormButtonOnSaveFromJSONTyped(json, false);
}

export function ApiFormButtonOnSaveFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiFormButtonOnSave {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    loadEditFormInline: !exists(json, 'loadEditFormInline')
      ? undefined
      : json['loadEditFormInline'],
  };
}

export function ApiFormButtonOnSaveToJSON(value?: ApiFormButtonOnSave | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    loadEditFormInline: value.loadEditFormInline,
  };
}
